import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import { fontWeights, colors } from '@/styles'
import Skeleton from '@/components/skeleton'

const TextWrapper = styled.div`
  width: 100%;
  margin: ${props => (props.margin ? props.margin : '0 0 8px 0')};
  padding: 8px 10px;
  background: ${colors.grey96};
  border-width: 1px 0px;
  border-style: solid;
  border-color: ${colors.grey88};
`

const LabelText = styled.span`
  font-weight: ${fontWeights.regular};
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey16};
  margin: 0;
  ${props =>
    props.isLocked &&
    `
    filter: blur(10px);
    color: ${colors.black};
    background-color: ${colors.grey96};
    -webkit-touch-callout: none;
    -webkit-user-select: none; 
    -khtml-user-select: none; 
    -moz-user-select: none; 
    -ms-user-select: none; 
    user-select: none; 
    cursor: not-allowed;
  `}
`

const WarningText = styled(LabelText)`
  color: ${colors.red40};
  font-weight: ${fontWeights.medium};
`
const SuccessText = styled(LabelText)`
  color: ${colors.green48};
  font-weight: ${fontWeights.medium};
`

const Empty = ({ isLocked, isActive, isLoading }) => {
  const { t } = useTranslation()
  return (
    <TextWrapper>
      {isLoading ? (
        <Skeleton width={'100%'} height={40} />
      ) : (
        <LabelText isLocked={isLocked}>
          {!isActive ? (
            <Trans i18nKey={'l.application.credit_summary.no_credit_info.label'} t={t}>
              We were <WarningText> unable to retrieve</WarningText> this applicant's credit check
              report from Equifax.
            </Trans>
          ) : (
            <Trans i18nKey={'l.application.credit_summary.no_collections.label'} t={t}>
              This applicant has <SuccessText>no collection record</SuccessText>.
            </Trans>
          )}
        </LabelText>
      )}
    </TextWrapper>
  )
}

export default Empty
